const actions = {
    // Read and reset single document
    MYINVOIS_READ_DOCUMENT_REQUEST: 'MYINVOIS_READ_DOCUMENT_REQUEST',
    MYINVOIS_READ_DOCUMENT_SUCCESS: 'MYINVOIS_READ_DOCUMENT_SUCCESS',
    MYINVOIS_READ_DOCUMENT_ERROR: 'MYINVOIS_READ_DOCUMENT_ERROR',

    MYINVOIS_RESET_DOCUMENT: 'MYINVOIS_RESET_DOCUMENT',

    // Read and reset all documents
    MYINVOIS_READ_ALL_DOCUMENTS_REQUEST: 'MYINVOIS_READ_ALL_DOCUMENTS_REQUEST',
    MYINVOIS_READ_ALL_DOCUMENTS_SUCCESS: 'MYINVOIS_READ_ALL_DOCUMENTS_SUCCESS',
    MYINVOIS_READ_ALL_DOCUMENTS_ERROR: 'MYINVOIS_READ_ALL_DOCUMENTS_ERROR',

    MYINVOIS_RESET_DOCUMENTS: 'MYINVOIS_RESET_DOCUMENTS',

    // Resubmit and bulk resubmit documents
    MYINVOIS_RESUBMIT_DOCUMENT_REQUEST: 'MYINVOIS_RESUBMIT_DOCUMENT_REQUEST',
    MYINVOIS_RESUBMIT_DOCUMENT_SUCCESS: 'MYINVOIS_RESUBMIT_DOCUMENT_SUCCESS',
    MYINVOIS_RESUBMIT_DOCUMENT_ERROR: 'MYINVOIS_RESUBMIT_DOCUMENT_ERROR',

    MYINVOIS_BULK_RESUBMIT_DOCUMENTS_REQUEST: 'MYINVOIS_BULK_RESUBMIT_DOCUMENTS_REQUEST',
    MYINVOIS_BULK_RESUBMIT_DOCUMENTS_SUCCESS: 'MYINVOIS_BULK_RESUBMIT_DOCUMENTS_SUCCESS',
    MYINVOIS_BULK_RESUBMIT_DOCUMENTS_ERROR: 'MYINVOIS_BULK_RESUBMIT_DOCUMENTS_ERROR',

    // Cancel Document (only allow cancelling consolidated for now)
    MYINVOIS_CANCEL_DOCUMENT_REQUEST: 'MYINVOIS_CANCEL_DOCUMENT_REQUEST',
    MYINVOIS_CANCEL_DOCUMENT_SUCCESS: 'MYINVOIS_CANCEL_DOCUMENT_SUCCESS',
    MYINVOIS_CANCEL_DOCUMENT_ERROR: 'MYINVOIS_CANCEL_DOCUMENT_ERROR',

    // Read all transactions
    MYINVOIS_READ_ALL_TRANSACTIONS_REQUEST: 'MYINVOIS_READ_ALL_TRANSACTIONS_REQUEST',
    MYINVOIS_READ_ALL_TRANSACTIONS_SUCCESS: 'MYINVOIS_READ_ALL_TRANSACTIONS_SUCCESS',
    MYINVOIS_READ_ALL_TRANSACTIONS_ERROR: 'MYINVOIS_READ_ALL_TRANSACTIONS_ERROR',

    // Submit and bulk Submit transactions
    MYINVOIS_SUBMIT_TRANSACTION_REQUEST: 'MYINVOIS_SUBMIT_TRANSACTION_REQUEST',
    MYINVOIS_SUBMIT_TRANSACTION_SUCCESS: 'MYINVOIS_SUBMIT_TRANSACTION_SUCCESS',
    MYINVOIS_SUBMIT_TRANSACTION_ERROR: 'MYINVOIS_SUBMIT_TRANSACTION_ERROR',

    MYINVOIS_BULK_SUBMIT_TRANSACTIONS_REQUEST: 'MYINVOIS_BULK_SUBMIT_TRANSACTIONS_REQUEST',
    MYINVOIS_BULK_SUBMIT_TRANSACTIONS_SUCCESS: 'MYINVOIS_BULK_SUBMIT_TRANSACTIONS_SUCCESS',
    MYINVOIS_BULK_SUBMIT_TRANSACTIONS_ERROR: 'MYINVOIS_BULK_SUBMIT_TRANSACTIONS_ERROR',

    // Read consolidated transactions
    MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST: 'MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST',
    MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS: 'MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS',
    MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_ERROR: 'MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_ERROR',

    MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST: 'MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST',
    MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS: 'MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS',
    MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_ERROR: 'MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_ERROR',

    MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST: 'MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST',
    MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS: 'MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS',
    MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_ERROR: 'MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_ERROR',

    MYINVOIS_RESET_TRANSACTIONS_FOR_CONSOLIDATED: 'MYINVOIS_RESET_TRANSACTIONS_FOR_CONSOLIDATED',

    // Reread transactions's document status
    MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_REQUEST: 'MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_REQUEST',
    MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_SUCCESS: 'MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_SUCCESS',
    MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_ERROR: 'MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_ERROR',

    MYINVOIS_REFETCH_DOCUMENT_STATUS_REQUEST: 'MYINVOIS_REFETCH_DOCUMENT_STATUS_REQUEST',
    MYINVOIS_REFETCH_DOCUMENT_STATUS_SUCCESS: 'MYINVOIS_REFETCH_DOCUMENT_STATUS_SUCCESS',
    MYINVOIS_REFETCH_DOCUMENT_STATUS_ERROR: 'MYINVOIS_REFETCH_DOCUMENT_STATUS_ERROR',

    // ---- ---- ---- ---- MINIPOS ---- ---- ---- ---- //
    // Read all transactions
    MYINVOIS_READ_ALL_MINIPOS_REQUEST: 'MYINVOIS_READ_ALL_MINIPOS_REQUEST',
    MYINVOIS_READ_ALL_MINIPOS_SUCCESS: 'MYINVOIS_READ_ALL_MINIPOS_SUCCESS',
    MYINVOIS_READ_ALL_MINIPOS_ERROR: 'MYINVOIS_READ_ALL_MINIPOS_ERROR',

    // Submit and bulk Submit transactions
    MYINVOIS_SUBMIT_MINIPOS_REQUEST: 'MYINVOIS_SUBMIT_MINIPOS_REQUEST',
    MYINVOIS_SUBMIT_MINIPOS_SUCCESS: 'MYINVOIS_SUBMIT_MINIPOS_SUCCESS',
    MYINVOIS_SUBMIT_MINIPOS_ERROR: 'MYINVOIS_SUBMIT_MINIPOS_ERROR',

    MYINVOIS_BULK_SUBMIT_MINIPOS_REQUEST: 'MYINVOIS_BULK_SUBMIT_MINIPOS_REQUEST',
    MYINVOIS_BULK_SUBMIT_MINIPOS_SUCCESS: 'MYINVOIS_BULK_SUBMIT_MINIPOS_SUCCESS',
    MYINVOIS_BULK_SUBMIT_MINIPOS_ERROR: 'MYINVOIS_BULK_SUBMIT_MINIPOS_ERROR',

    // Read consolidated miniPOS
    MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_REQUEST: 'MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_REQUEST',
    MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_SUCCESS: 'MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_SUCCESS',
    MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_ERROR: 'MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_ERROR',

    MYINVOIS_READ_UNSUBMITTABLE_MINIPOS_FOR_CONSOLIDATED_REQUEST: 'MYINVOIS_READ_UNSUBMITTABLE_MINIPOS_FOR_CONSOLIDATED_REQUEST',
    MYINVOIS_READ_UNSUBMITTABLE_MINIPOS_FOR_CONSOLIDATED_SUCCESS: 'MYINVOIS_READ_UNSUBMITTABLE_MINIPOS_FOR_CONSOLIDATED_SUCCESS',
    MYINVOIS_READ_UNSUBMITTABLE_MINIPOS_FOR_CONSOLIDATED_ERROR: 'MYINVOIS_READ_UNSUBMITTABLE_MINIPOS_FOR_CONSOLIDATED_ERROR',

    MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_REQUEST: 'MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_REQUEST',
    MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_SUCCESS: 'MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_SUCCESS',
    MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_ERROR: 'MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_ERROR',

    MYINVOIS_RESET_MINIPOS_FOR_CONSOLIDATED: 'MYINVOIS_RESET_MINIPOS_FOR_CONSOLIDATED',

    MYINVOIS_RESET_ALL: 'MYINVOIS_RESET_ALL',

    MYINVOIS_VALIDATE_TIN_REG_NO_REQUEST: 'MYINVOIS_VALIDATE_TIN_REG_NO_REQUEST',
    MYINVOIS_VALIDATE_TIN_REG_NO_SUCCESS: 'MYINVOIS_VALIDATE_TIN_REG_NO_SUCCESS',
    MYINVOIS_VALIDATE_TIN_REG_NO_ERROR: 'MYINVOIS_VALIDATE_TIN_REG_NO_ERROR',

    MYINVOIS_SET_VALIDATE_TIN_REG_NO_RESULT: 'MYINVOIS_SET_VALIDATE_TIN_REG_NO_RESULT',

    // Read incoming document
    MYINVOIS_READ_INCOMING_DOCUMENT_REQUEST: 'MYINVOIS_READ_INCOMING_DOCUMENT_REQUEST',
    MYINVOIS_READ_INCOMING_DOCUMENT_SUCCESS: 'MYINVOIS_READ_INCOMING_DOCUMENT_SUCCESS',
    MYINVOIS_READ_INCOMING_DOCUMENT_ERROR: 'MYINVOIS_READ_INCOMING_DOCUMENT_ERROR',

    MYINVOIS_RESET_INCOMING_DOCUMENT: 'MYINVOIS_RESET_INCOMING_DOCUMENT',

    // Read all incoming documents
    MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_REQUEST: 'MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_REQUEST',
    MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_SUCCESS: 'MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_SUCCESS',
    MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_ERROR: 'MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_ERROR',

    MYINVOIS_RESET_INCOMING_DOCUMENTS: 'MYINVOIS_RESET_INCOMING_DOCUMENTS',

    // Delete incoming document
    MYINVOIS_DELETE_INCOMING_DOCUMENT_REQUEST: 'MYINVOIS_DELETE_INCOMING_DOCUMENT_REQUEST',
    MYINVOIS_DELETE_INCOMING_DOCUMENT_SUCCESS: 'MYINVOIS_DELETE_INCOMING_DOCUMENT_SUCCESS',
    MYINVOIS_DELETE_INCOMING_DOCUMENT_ERROR: 'MYINVOIS_DELETE_INCOMING_DOCUMENT_ERROR',

    MYINVOIS_POST_INCOMING_DOCUMENT_REQUEST: 'MYINVOIS_POST_INCOMING_DOCUMENT_REQUEST',
    MYINVOIS_POST_INCOMING_DOCUMENT_SUCCESS: 'MYINVOIS_POST_INCOMING_DOCUMENT_SUCCESS',
    MYINVOIS_POST_INCOMING_DOCUMENT_ERROR: 'MYINVOIS_POST_INCOMING_DOCUMENT_ERROR',

    readMyInvoisDocument: id => ({
        type: actions.MYINVOIS_READ_DOCUMENT_REQUEST,
        id,
    }),

    resetMyInvoisDocument: () => ({
        type: actions.MYINVOIS_RESET_DOCUMENT,
    }),

    readAllMyInvoisDocuments: request => ({
        type: actions.MYINVOIS_READ_ALL_DOCUMENTS_REQUEST,
        request,
    }),

    resetMyInvoisDocuments: () => ({
        type: actions.MYINVOIS_RESET_DOCUMENTS,
    }),

    resubmitMyInvoisDocument: documentId => ({
        type: actions.MYINVOIS_RESUBMIT_DOCUMENT_REQUEST,
        documentId,
    }),

    readMyInvoisIncomingDocument: id => ({
        type: actions.MYINVOIS_READ_INCOMING_DOCUMENT_REQUEST,
        id,
    }),

    postMyInvoisIncomingDocument: (request, id) => ({
        type: actions.MYINVOIS_POST_INCOMING_DOCUMENT_REQUEST,
        request,
        id,
    }),

    resetMyInvoisIncomingDocument: () => ({
        type: actions.MYINVOIS_RESET_INCOMING_DOCUMENT,
    }),

    readAllMyInvoisIncomingDocuments: request => ({
        type: actions.MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_REQUEST,
        request,
    }),

    resetMyInvoisIncomingDocuments: () => ({
        type: actions.MYINVOIS_RESET_INCOMING_DOCUMENTS,
    }),

    deleteMyInvoisIncomingDocument: id => ({
        type: actions.MYINVOIS_DELETE_INCOMING_DOCUMENT_REQUEST,
        id,
    }),

    bulkResubmitMyInvoisDocuments: documentIds => ({
        type: actions.MYINVOIS_BULK_RESUBMIT_DOCUMENTS_REQUEST,
        documentIds,
    }),

    cancelMyInvoisDocument: documentId => ({
        type: actions.MYINVOIS_CANCEL_DOCUMENT_REQUEST,
        documentId,
    }),

    readAllMyInvoisTransactions: request => ({
        type: actions.MYINVOIS_READ_ALL_TRANSACTIONS_REQUEST,
        request,
    }),

    bulkSubmitMyInvoisTransactions: transactionIds => ({
        type: actions.MYINVOIS_BULK_SUBMIT_TRANSACTIONS_REQUEST,
        transactionIds,
    }),

    submitMyInvoisTransaction: (transactionId, isSubmit) => ({
        type: actions.MYINVOIS_SUBMIT_TRANSACTION_REQUEST,
        transactionId,
        isSubmit,
    }),

    readTransactionsForConsolidated: request => ({
        type: actions.MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST,
        request,
    }),

    // Read MyInvois document status for a transaction (invoice, bill, CN, Purchase CN)
    refetchTransactionMyInvoisDocumentStatus: (id, transactionType) => ({
        type: actions.MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_REQUEST,
        id,
        transactionType,
    }),

    refetchMyInvoisDocumentStatus: id => ({
        type: actions.MYINVOIS_REFETCH_DOCUMENT_STATUS_REQUEST,
        id,
    }),

    readAllMyInvoisMiniPos: request => ({
        type: actions.MYINVOIS_READ_ALL_MINIPOS_REQUEST,
        request,
    }),

    bulkSubmitMyInvoisMiniPos: orderIds => ({
        type: actions.MYINVOIS_BULK_SUBMIT_MINIPOS_REQUEST,
        orderIds,
    }),

    submitMyInvoisMiniPos: (transactionId, isSubmit) => ({
        type: actions.MYINVOIS_SUBMIT_MINIPOS_REQUEST,
        transactionId,
        isSubmit,
    }),

    readMiniPosForConsolidated: request => ({
        type: actions.MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_REQUEST,
        request,
    }),

    submitMiniPosForConsolidated: request => ({
        type: actions.MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_REQUEST,
        request,
    }),

    readUnsubmittableTransactionsForConsolidated: request => ({
        type: actions.MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST,
        request,
    }),

    submitTransactionsForConsolidated: request => ({
        type: actions.MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST,
        request,
    }),

    resetTransactionsForConsolidated: () => ({
        type: actions.MYINVOIS_RESET_TRANSACTIONS_FOR_CONSOLIDATED,
    }),

    resetMyInvoisState: () => ({
        type: actions.MYINVOIS_RESET_ALL,
    }),

    validateTinRegNo: request => ({
        type: actions.MYINVOIS_VALIDATE_TIN_REG_NO_REQUEST,
        request,
    }),

    setValidateTinRegNoResult: isValid => ({
        type: actions.MYINVOIS_SET_VALIDATE_TIN_REG_NO_RESULT,
        isValid,
    }),

};
export default actions;
